// extracted by mini-css-extract-plugin
module.exports = {"fancy-date":"fancy-date__3Wxgk","weekday-label":"weekday-label__2XCPN","saturday":"saturday__3_4v1","sunday":"sunday__2m3VJ"};